module.exports = __webpack_public_path__ + "videos/home-53-hero_9x16_jp.73ac39c.mp4";